import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { getFontURL } from 'src/utils/getFontUrl';
import { trackingList } from 'src/utils/valueHTML';

// const TEXT_2_JUSTIFY = {
//   left: 'start',
//   center: 'center',
//   right: 'end'
// };

const RadiusFullCountdownHTML: FC = () => {
  // let templateWidth = useSelector((state: any) => state.template.templateWidth);
  // let templateHeight = useSelector(
  //   (state: any) => state.template.templateHeight
  // );
  // let bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  // let bgImageBlur = useSelector(
  //   (state: RootState) => state.imageUpload.bgImageBlur
  // );
  let radius = useSelector((state: RootState) => state.imageUpload.radius);
  let deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);

  let text = useSelector((state: RootState) => state.editText.text);
  let fontSize = useSelector((state: RootState) => state.editText.fontSize);
  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let color = useSelector((state: RootState) => state.editText.color);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  let textAlign = useSelector((state: RootState) => state.editText.textAlign);

  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  let btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  let btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  let btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  // let currentUser = useSelector((state: RootState) => state.client.userCompany);
  let tracking = useSelector((state: RootState) => state.trackings.tracking);
  let button1 = useSelector((state: RootState) => state.trackings.button1);
  let button2 = useSelector((state: RootState) => state.trackings.button2);

  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const countdownTitleFontURL = getFontURL(fontFamily?.countdown_title);
  const countdownFontURL = getFontURL(fontFamily?.countdown);
  const btnFontURL = getFontURL(btnFontFamily?.button);
  const subBtnFontURL = getFontURL(btnFontFamily?.sub_button);
  // const titleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.title}`;
  // const subTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.sub_title}`;
  // const countdownTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.countdown_title}`;
  // const countdownFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.countdown}`;
  // const btnFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.button}`;
  // const subBtnFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.sub_button}`;
  const plusImageUrl = 'https://i.ibb.co/qMpSJ4w/Group-20.png';
  const style = `
  @font-face {
    font-family: 'title';
    src: url('${titleFontURL}');
  }
  @font-face {
    font-family: 'subTitle';
    src: url('${subTitleFontURL}');
  }
  @font-face {
    font-family: 'countdownTitle';
    src: url('${countdownTitleFontURL}');
  }
  @font-face {
    font-family: 'countdown';
    src: url('${countdownFontURL}');
  }
  @font-face {
    font-family: 'button';
    src: url('${btnFontURL}');
  }
  @font-face {
    font-family: 'subButton';
    src: url('${subBtnFontURL}');
  }
    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html {
      font-size: 16px;
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
    }
    .backgroundImage {
      background: rgba(0, 0, 0, 0.8);
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }

    .close_btn {
      height: 1.5rem;
      position: absolute;
      top: 6%;
      right: 10%;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      display: flex;
      align-items: center;

      font-size: ${btnFontSize?.sub_button}rem;
      font-weight: ${btnFontWeight?.sub_button};
      color: ${btnColor?.sub_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.sub_button
        )
          ? btnFontFamily?.sub_button
          : 'subButton'
      };
      letter-spacing: 0.0225rem;
    }

    .center {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      display: flex;
      flex-direction: column;
      gap: 3rem;
    }
    .top {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .top_center {
      width: 80%;
    }
    .top .sub_title {
      height: 1.5rem;
      text-align: ${textAlign?.sub_title};
      font-size: ${fontSize?.sub_title}rem;
      font-weight: ${fontWeight?.sub_title};
      color: ${color?.sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.sub_title
        )
          ? fontFamily?.sub_title
          : 'subTitle'
      };
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .top .title {
      height: 3rem;
      text-align: ${textAlign?.title};
      font-size: ${fontSize?.title}rem;
      font-weight: ${fontWeight?.title};
      color: ${color?.title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.title
        )
          ? fontFamily?.title
          : 'title'
      };
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .circle_wrapper {
      width: 100%;
      height: 25rem;
      position: relative;
      text-align: center;
    }
    .circleImage  {
      width: 25rem;
      height: 25rem;

      ${
        bgImage?.background || bgImage?.background !== ''
          ? `background-image: url(${bgImage?.background})`
          : `background-color: #D9D9D9`
      };

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      border-radius: 25rem;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }
    .modal_wrapper {
      color: #000;
      font-size: 0.78513rem;
      font-weight: 400;
      font-family: Roboto;
    }
    .plus_btn button {
      width: 1.1rem;
      height: 1.1rem;
      
      background-image: url(${plusImageUrl});
      background-repeat: no-repeat;
      background-size: 1.1rem;
      background-position: center;

      font-size: 0;
      border: none;
      border-radius: 50%;
      background-color: transparent;
    }

    .countdown_grid {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      height: 100%;
    }
    .countdown_grid li {
      text-align: center;
    }
  
    .bottom {
      width: 100%;
    }
    .bottom ul {
      height: 2.5rem;
      padding: 0 5% 0 4%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      font-size: ${fontSize?.countdown}rem;
      font-weight: ${fontWeight?.countdown};
      color: ${color?.countdown};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.countdown
        )
          ? fontFamily?.countdown
          : 'countdown'
      };
    }
    .countdown.timer.finish_ment {
      font-size: ${fontSize?.countdown_title}rem;
      font-weight: ${fontWeight?.countdown_title};
      color: ${color?.countdown_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.countdown_title
        )
          ? fontFamily?.countdown_title
          : 'countdownTitle'
      };
    }
    .bottom li {
      list-style: none;      
    }
    .bottom .countdown_title {
      font-size: ${fontSize?.countdown_title}rem;
      font-weight: ${fontWeight?.countdown_title};
      color: ${color?.countdown_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.countdown_title
        )
          ? fontFamily?.countdown_title
          : 'countdownTitle'
      };
    }

    .bottom_btn {
      width: 100%;
      position: absolute;
      bottom: 0;
    }
    .bottom_btn button {
      width: 100%;
      height: 4.5rem;
      border: 0;
      padding: 1rem 2rem 1.5rem 2rem;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.button}rem;
      font-weight: ${btnFontWeight?.button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.button
        )
          ? btnFontFamily?.button
          : 'button'
      };
      color: ${btnColor?.button};
      border-radius: ${radius?.button}px ${radius?.button}px 0 0;
      background-color: rgba(${btnBgColorR?.button}, ${btnBgColorG?.button}, ${
    btnBgColorB?.button
  }, ${btnBgColorA?.button});
    }
  
    #days,
		#hours,
		#mins {
			font-size: 0.8rem;
		}

    @media screen and (max-height: 740px) {
      .center {
        gap: 0.5rem;
      }

      .circle_wrapper {
        height: 20rem;
      }
      .circleImage  {
        width: 20rem;
        height: 20rem;
        border-radius: 20rem;
      }
    }

    @media screen and (min-width: 768px) {
      .countdown_grid {
        gap: 1rem;
			}
			.bottom ul {
        padding: 0 10% 0 10%;
      }

			.bottom .countdown_title {
				font-size: 1.5rem;
			}
			#days,
			#hours,
			#mins {
				font-size: 1.2rem;
			}
		}  	  
  `;

  const html = `
    <div class="root">
      <div class="backgroundImage" onclick="appboyBridge.logClick('1'); appboyBridge.closeMessage();"></div>
      <div class="close_btn">${btnText?.sub_button}</div>

      <div class="center">
        <div class="top">
          <div class="top_center">
            <div class="sub_title">${changeEnterHTML(
              text?.sub_title.replace(/\n/g, '')
            )}</div>
            <div class="title">${changeEnterHTML(
              text?.title.replace(/\n/g, '')
            )}</div>
          </div>
        </div>

        <div class="circle_wrapper">
          <div class="circleImage">
            ${
              !bgImage?.background || bgImage?.background === ''
                ? `<div class="modal_wrapper">
                텍스트가 포함된
                <br />
                이미지 또는 배경 이미지를
                <br />
                추가하세요
                <div class="plus_btn">
                  <button>plus</button>
                </div>
              </div>`
                : ``
            }
          </div>
        </div>

        <div class="bottom">
          <ul class="countdown timer" >
            <li class="countdown_title">Time Left</li>
            <div class='countdown timer' id="timer"></div>
            <div class="countdown_grid">
            	<li id="cDay">00</li>
					  	<li id="days">:</li>
					  	<li id="cHour">00</li>
				  		<li id="hours">:</li>
					  	<li id="cMin">00</li>
						  <li id="mins"></li>
            </div>
          </ul>
        </div>
      </div>
      <div class="bottom_btn">
        <button>${btnText?.button}</button>
      </div>
    </div>
  `;

  let tracking_list = `[`;
  for (let i = 0; i < tracking?.button?.length; i++) {
    tracking_list += `['${tracking?.background?.[i]}', '${tracking?.button?.[i]}', '${tracking?.sub_button?.[i]}'],`;
  }
  tracking_list += ']';

  let tracking_button_list = trackingList(
    'RADIUS FULL COUNTDOWN',
    button1,
    button2
  );

  // let customEvent = "오늘하루 보지않기 클릭_{{campaign.${name}}}";
  const js = `
    window.onload = function(){

      const countdownTimer = function (id1, id2, id3, id4, date) {
			let _vData = date;
			let timer;

			function showRemaining() {
				let now = new Date();
				let distDt = _vData - now;

				if (distDt < 0) {
					clearInterval(timer);
					const countdownGrid = document.querySelector('.countdown_grid');
          if (countdownGrid) {
            countdownGrid.remove();
          }
					document.getElementById(id4).textContent = "종료되었습니다.";
					const timerElement = document.querySelector('.timer');
          if (timerElement) {
          timerElement.classList.add('finish_ment');
          }
					return;
				}

				let days = Math.floor(distDt / (1000 * 60 * 60 * 24));
				let hours = Math.floor((distDt % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				let minutes = Math.floor((distDt % (1000 * 60 * 60)) / (1000 * 60));
				let seconds = Math.floor((distDt % (1000 * 60)) / 1000);

				if (days > 0 || hours >= 24) {
					// 24시간 이상일 경우
					const units = ["days", "hours", "mins"];
					units.forEach((unit) => {
						const element = document.getElementById(unit);
						element.textContent = unit;						
					});
          const bottomUl = document.querySelector('.bottom ul');
          bottomUl.style.fontSize = '2rem';
					document.getElementById(id1).textContent = \`\${days.toString()}\`;
					document.getElementById(id2).textContent = \`\${hours.toString().padStart(2, "0")}\`;
					document.getElementById(id3).textContent = \`\${minutes.toString().padStart(2, "0")}\`;
					
				} else {
					// 24시간 미만일 경우
					document.getElementById(id1).textContent = hours.toString().padStart(2, "0");
					document.getElementById(id2).textContent = minutes.toString().padStart(2, "0");
					document.getElementById(id3).textContent = seconds.toString().padStart(2, "0");
					
				}
			}

			timer = setInterval(showRemaining, 1000);
		};

      countdownTimer("cDay", "cHour", "cMin", "timer", new Date(${
        text?.countdown?.year
      },${text?.countdown?.month - 1},${text?.countdown?.date},${
    text?.countdown?.hour
  },${text?.countdown?.min}))
      
      let tracking = ${tracking_list};
      let button1 = ${tracking_button_list[0]};
      let button2 = ${tracking_button_list[1]};
      $('.close_btn').click(function() {
        appboyBridge.logClick(tracking[0][2]);
        try {
          if (button1[2].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[2].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        appboyBridge.closeMessage();
      });
      $('.circleImage').click(function() {
        appboyBridge.logClick(tracking[0][0]);
        try {
          if (button1[0].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[0].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        window.location = "${deeplink?.background}";
      });
      $('.bottom_btn').click(function() {
        appboyBridge.logClick(tracking[0][1]);
        try {
          if (button1[1].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[1].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        window.location = "${deeplink?.background}";
      });
    };
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <style dangerouslySetInnerHTML={{ __html: style }}></style>
        <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.js"></script>
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }}></body>
      <script dangerouslySetInnerHTML={{ __html: js }}></script>
    </>
  );
};

export default RadiusFullCountdownHTML;
